module.exports = __webpack_public_path__ + "img/amb-ewa-wellness.fffb0e50.png";